const URL = process.env.PUBLIC_URL;
const data = {
  countryCode: [
    {
      "id": "1",
      "name": "US",
      "displayText": "United States (+1)",
      "country": "United States",
      "locale": "",
      "flag": `${URL}/Flagkit/US.imageset/US.png`
    },
    {
      "id": "297",
      "name": "AW",
      "displayText": "Aruba (+297)",
      "country": "Aruba",
      "locale": "",
      "flag": `${URL}/Flagkit/AW.imageset/AW.png`
    },
    {
      "id": "93",
      "name": "AF",
      "displayText": "Afghanistan (+93)",
      "country": "Afghanistan",
      "locale": "",
      "flag": `${URL}/Flagkit/AF.imageset/AF.png`
    },
    {
      "id": "244",
      "name": "AO",
      "displayText": "Angola (+244)",
      "country": "Angola",
      "locale": "",
      "flag": `${URL}/Flagkit/AO.imageset/AO.png`
    },
    {
      "id": "1264",
      "name": "AI",
      "displayText": "Anguilla (+1264)",
      "country": "Anguilla",
      "locale": "",
      "flag": `${URL}/Flagkit/AI.imageset/AI.png`
    },
    {
      "id": "358",
      "name": "AX",
      "displayText": "Ãland Islands (+358)",
      "country": "Ãland Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/AX.imageset/AX.png`
    },
    {
      "id": "355",
      "name": "AL",
      "displayText": "Albania (+355)",
      "country": "Albania",
      "locale": "",
      "flag": `${URL}/Flagkit/AL.imageset/AL.png`
    },
    {
      "id": "376",
      "name": "AD",
      "displayText": "Andorra (+376)",
      "country": "Andorra",
      "locale": "",
      "flag": `${URL}/Flagkit/AD.imageset/AD.png`
    },
    {
      "id": "971",
      "name": "AE",
      "displayText": "United Arab Emirates (+971)",
      "country": "United Arab Emirates",
      "locale": "",
      "flag": `${URL}/Flagkit/AE.imageset/AE.png`
    },
    {
      "id": "54",
      "name": "AR",
      "displayText": "Argentina (+54)",
      "country": "Argentina",
      "locale": "",
      "flag": `${URL}/Flagkit/AR.imageset/AR.png`
    },
    {
      "id": "374",
      "name": "AM",
      "displayText": "Armenia (+374)",
      "country": "Armenia",
      "locale": "",
      "flag": `${URL}/Flagkit/AM.imageset/AM.png`
    },
    {
      "id": "1684",
      "name": "AS",
      "displayText": "American Samoa (+1684)",
      "country": "American Samoa",
      "locale": "",
      "flag": `${URL}/Flagkit/AS.imageset/AS.png`
    },
    {
      "id": "1268",
      "name": "AG",
      "displayText": "Antigua and Barbuda (+1268)",
      "country": "Antigua and Barbuda",
      "locale": "",
      "flag": `${URL}/Flagkit/AG.imageset/AG.png`
    },
    {
      "id": "61",
      "name": "AU",
      "displayText": "Australia (+61)",
      "country": "Australia",
      "locale": "",
      "flag": `${URL}/Flagkit/AU.imageset/AU.png`
    },
    {
      "id": "43",
      "name": "AT",
      "displayText": "Austria (+43)",
      "country": "Austria",
      "locale": "",
      "flag": `${URL}/Flagkit/AT.imageset/AT.png`
    },
    {
      "id": "994",
      "name": "AZ",
      "displayText": "Azerbaijan (+994)",
      "country": "Azerbaijan",
      "locale": "",
      "flag": `${URL}/Flagkit/AZ.imageset/AZ.png`
    },
    {
      "id": "257",
      "name": "BI",
      "displayText": "Burundi (+257)",
      "country": "Burundi",
      "locale": "",
      "flag": `${URL}/Flagkit/BI.imageset/BI.png`
    },
    {
      "id": "32",
      "name": "BE",
      "displayText": "Belgium (+32)",
      "country": "Belgium",
      "locale": "",
      "flag": `${URL}/Flagkit/BE.imageset/BE.png`
    },
    {
      "id": "229",
      "name": "BJ",
      "displayText": "Benin (+229)",
      "country": "Benin",
      "locale": "",
      "flag": `${URL}/Flagkit/BJ.imageset/BJ.png`
    },
    {
      "id": "226",
      "name": "BF",
      "displayText": "Burkina Faso (+226)",
      "country": "Burkina Faso",
      "locale": "",
      "flag": `${URL}/Flagkit/BF.imageset/BF.png`
    },
    {
      "id": "880",
      "name": "BD",
      "displayText": "Bangladesh (+880)",
      "country": "Bangladesh",
      "locale": "",
      "flag": `${URL}/Flagkit/BD.imageset/BD.png`
    },
    {
      "id": "359",
      "name": "BG",
      "displayText": "Bulgaria (+359)",
      "country": "Bulgaria",
      "locale": "",
      "flag": `${URL}/Flagkit/BG.imageset/BG.png`
    },
    {
      "id": "973",
      "name": "BH",
      "displayText": "Bahrain (+973)",
      "country": "Bahrain",
      "locale": "",
      "flag": `${URL}/Flagkit/BH.imageset/BH.png`
    },
    {
      "id": "1242",
      "name": "BS",
      "displayText": "Bahamas (+1242)",
      "country": "Bahamas",
      "locale": "",
      "flag": `${URL}/Flagkit/BS.imageset/BS.png`
    },
    {
      "id": "387",
      "name": "BA",
      "displayText": "Bosnia and Herzegovina (+387)",
      "country": "Bosnia and Herzegovina",
      "locale": "",
      "flag": `${URL}/Flagkit/BA.imageset/BA.png`
    },
    {
      "id": "590",
      "name": "BL",
      "displayText": "Saint BarthÃ©lemy (+590)",
      "country": "Saint BarthÃ©lemy",
      "locale": "",
      "flag": `${URL}/Flagkit/BL.imageset/BL.png`
    },
    {
      "id": "375",
      "name": "BY",
      "displayText": "Belarus (+375)",
      "country": "Belarus",
      "locale": "",
      "flag": `${URL}/Flagkit/BY.imageset/BY.png`
    },
    {
      "id": "501",
      "name": "BZ",
      "displayText": "Belize (+501)",
      "country": "Belize",
      "locale": "",
      "flag": `${URL}/Flagkit/BZ.imageset/BZ.png`
    },
    {
      "id": "1441",
      "name": "BM",
      "displayText": "Bermuda (+1441)",
      "country": "Bermuda",
      "locale": "",
      "flag": `${URL}/Flagkit/BM.imageset/BM.png`
    },
    {
      "id": "591",
      "name": "BO",
      "displayText": "Bolivia (+591)",
      "country": "Bolivia",
      "locale": "",
      "flag": `${URL}/Flagkit/BO.imageset/BO.png`
    },
    {
      "id": "55",
      "name": "BR",
      "displayText": "Brazil (+55)",
      "country": "Brazil",
      "locale": "",
      "flag": `${URL}/Flagkit/BR.imageset/BR.png`
    },
    {
      "id": "1",
      "name": "BB",
      "displayText": "Barbados (+1)",
      "country": "Barbados",
      "locale": "",
      "flag": `${URL}/Flagkit/BB.imageset/BB.png`
    },
    {
      "id": "673",
      "name": "BN",
      "displayText": "Brunei (+673)",
      "country": "Brunei",
      "locale": "",
      "flag": `${URL}/Flagkit/BN.imageset/BN.png`
    },
    {
      "id": "975",
      "name": "BT",
      "displayText": "Bhutan (+975)",
      "country": "Bhutan",
      "locale": "",
      "flag": `${URL}/Flagkit/BT.imageset/BT.png`
    },
    {
      "id": "267",
      "name": "BW",
      "displayText": "Botswana (+267)",
      "country": "Botswana",
      "locale": "",
      "flag": `${URL}/Flagkit/BW.imageset/BW.png`
    },
    {
      "id": "236",
      "name": "CF",
      "displayText": "Central African Republic (+236)",
      "country": "Central African Republic",
      "locale": "",
      "flag": `${URL}/Flagkit/CF.imageset/CF.png`
    },
    {
      "id": "1",
      "name": "CA",
      "displayText": "Canada (+1)",
      "country": "Canada",
      "locale": "",
      "flag": `${URL}/Flagkit/CA.imageset/CA.png`
    },
    {
      "id": "61",
      "name": "CC",
      "displayText": "Cocos (Keeling) Islands (+61)",
      "country": "Cocos (Keeling) Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/CC.imageset/CC.png`
    },
    {
      "id": "41",
      "name": "CH",
      "displayText": "Switzerland (+41)",
      "country": "Switzerland",
      "locale": "",
      "flag": `${URL}/Flagkit/CH.imageset/CH.png`
    },
    {
      "id": "56",
      "name": "CL",
      "displayText": "Chile (+56)",
      "country": "Chile",
      "locale": "",
      "flag": `${URL}/Flagkit/CL.imageset/CL.png`
    },
    {
      "id": "86",
      "name": "CN",
      "displayText": "China (+86)",
      "country": "China",
      "locale": "",
      "flag": `${URL}/Flagkit/CN.imageset/CN.png`
    },
    {
      "id": "225",
      "name": "CI",
      "displayText": "Ivory Coast (+225)",
      "country": "Ivory Coast",
      "locale": "",
      "flag": `${URL}/Flagkit/CI.imageset/CI.png`
    },
    {
      "id": "237",
      "name": "CM",
      "displayText": "Cameroon (+237)",
      "country": "Cameroon",
      "locale": "",
      "flag": `${URL}/Flagkit/CM.imageset/CM.png`
    },
    {
      "id": "243",
      "name": "CD",
      "displayText": "DR Congo (+243)",
      "country": "DR Congo",
      "locale": "",
      "flag": `${URL}/Flagkit/CD.imageset/CD.png`
    },
    {
      "id": "242",
      "name": "CG",
      "displayText": "Republic of the Congo (+242)",
      "country": "Republic of the Congo",
      "locale": "",
      "flag": `${URL}/Flagkit/CG.imageset/CG.png`
    },
    {
      "id": "682",
      "name": "CK",
      "displayText": "Cook Islands (+682)",
      "country": "Cook Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/CK.imageset/CK.png`
    },
    {
      "id": "57",
      "name": "CO",
      "displayText": "Colombia (+57)",
      "country": "Colombia",
      "locale": "",
      "flag": `${URL}/Flagkit/CO.imageset/CO.png`
    },
    {
      "id": "269",
      "name": "KM",
      "displayText": "Comoros (+269)",
      "country": "Comoros",
      "locale": "",
      "flag": `${URL}/Flagkit/KM.imageset/KM.png`
    },
    {
      "id": "238",
      "name": "CV",
      "displayText": "Cape Verde (+238)",
      "country": "Cape Verde",
      "locale": "",
      "flag": `${URL}/Flagkit/CV.imageset/CV.png`
    },
    {
      "id": "506",
      "name": "CR",
      "displayText": "Costa Rica (+506)",
      "country": "Costa Rica",
      "locale": "",
      "flag": `${URL}/Flagkit/CR.imageset/CR.png`
    },
    {
      "id": "53",
      "name": "CU",
      "displayText": "Cuba (+53)",
      "country": "Cuba",
      "locale": "",
      "flag": `${URL}/Flagkit/CU.imageset/CU.png`
    },
    {
      "id": "5999",
      "name": "CW",
      "displayText": "CuraÃ§ao (+5999)",
      "country": "CuraÃ§ao",
      "locale": "",
      "flag": `${URL}/Flagkit/CW.imageset/CW.png`
    },
    {
      "id": "61",
      "name": "CX",
      "displayText": "Christmas Island (+61)",
      "country": "Christmas Island",
      "locale": "",
      "flag": `${URL}/Flagkit/CX.imageset/CX.png`
    },
    {
      "id": "1",
      "name": "KY",
      "displayText": "Cayman Islands (+1)",
      "country": "Cayman Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/KY.imageset/KY.png`
    },
    {
      "id": "357",
      "name": "CY",
      "displayText": "Cyprus (+357)",
      "country": "Cyprus",
      "locale": "",
      "flag": `${URL}/Flagkit/CY.imageset/CY.png`
    },
    {
      "id": "420",
      "name": "CZ",
      "displayText": "Czechia (+420)",
      "country": "Czechia",
      "locale": "",
      "flag": `${URL}/Flagkit/CZ.imageset/CZ.png`
    },
    {
      "id": "49",
      "name": "DE",
      "displayText": "Germany (+49)",
      "country": "Germany",
      "locale": "",
      "flag": `${URL}/Flagkit/DE.imageset/DE.png`
    },
    {
      "id": "253",
      "name": "DJ",
      "displayText": "Djibouti (+253)",
      "country": "Djibouti",
      "locale": "",
      "flag": `${URL}/Flagkit/DJ.imageset/DJ.png`
    },
    {
      "id": "1767",
      "name": "DM",
      "displayText": "Dominica (+1767)",
      "country": "Dominica",
      "locale": "",
      "flag": `${URL}/Flagkit/DM.imageset/DM.png`
    },
    {
      "id": "45",
      "name": "DK",
      "displayText": "Denmark (+45)",
      "country": "Denmark",
      "locale": "",
      "flag": `${URL}/Flagkit/DK.imageset/DK.png`
    },
    {
      "id": "1",
      "name": "DO",
      "displayText": "Dominican Republic (+1)",
      "country": "Dominican Republic",
      "locale": "",
      "flag": `${URL}/Flagkit/DO.imageset/DO.png`
    },
    {
      "id": "213",
      "name": "DZ",
      "displayText": "Algeria (+213)",
      "country": "Algeria",
      "locale": "",
      "flag": `${URL}/Flagkit/DZ.imageset/DZ.png`
    },
    {
      "id": "593",
      "name": "EC",
      "displayText": "Ecuador (+593)",
      "country": "Ecuador",
      "locale": "",
      "flag": `${URL}/Flagkit/EC.imageset/EC.png`
    },
    {
      "id": "20",
      "name": "EG",
      "displayText": "Egypt (+20)",
      "country": "Egypt",
      "locale": "",
      "flag": `${URL}/Flagkit/EG.imageset/EG.png`
    },
    {
      "id": "291",
      "name": "ER",
      "displayText": "Eritrea (+291)",
      "country": "Eritrea",
      "locale": "",
      "flag": `${URL}/Flagkit/ER.imageset/ER.png`
    },
    {
      "id": "212",
      "name": "EH",
      "displayText": "Western Sahara (+212)",
      "country": "Western Sahara",
      "locale": "",
      "flag": `${URL}/Flagkit/EH.imageset/EH.png`
    },
    {
      "id": "34",
      "name": "ES",
      "displayText": "Spain (+34)",
      "country": "Spain",
      "locale": "",
      "flag": `${URL}/Flagkit/ES.imageset/ES.png`
    },
    {
      "id": "372",
      "name": "EE",
      "displayText": "Estonia (+372)",
      "country": "Estonia",
      "locale": "",
      "flag": `${URL}/Flagkit/EE.imageset/EE.png`
    },
    {
      "id": "251",
      "name": "ET",
      "displayText": "Ethiopia (+251)",
      "country": "Ethiopia",
      "locale": "",
      "flag": `${URL}/Flagkit/ET.imageset/ET.png`
    },
    {
      "id": "358",
      "name": "FI",
      "displayText": "Finland (+358)",
      "country": "Finland",
      "locale": "",
      "flag": `${URL}/Flagkit/FI.imageset/FI.png`
    },
    {
      "id": "679",
      "name": "FJ",
      "displayText": "Fiji (+679)",
      "country": "Fiji",
      "locale": "",
      "flag": `${URL}/Flagkit/FJ.imageset/FJ.png`
    },
    {
      "id": "500",
      "name": "FK",
      "displayText": "Falkland Islands (+500)",
      "country": "Falkland Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/FK.imageset/FK.png`
    },
    {
      "id": "33",
      "name": "FR",
      "displayText": "France (+33)",
      "country": "France",
      "locale": "",
      "flag": `${URL}/Flagkit/FR.imageset/FR.png`
    },
    {
      "id": "298",
      "name": "FO",
      "displayText": "Faroe Islands (+298)",
      "country": "Faroe Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/FO.imageset/FO.png`
    },
    {
      "id": "691",
      "name": "FM",
      "displayText": "Micronesia (+691)",
      "country": "Micronesia",
      "locale": "",
      "flag": `${URL}/Flagkit/FM.imageset/FM.png`
    },
    {
      "id": "241",
      "name": "GA",
      "displayText": "Gabon (+241)",
      "country": "Gabon",
      "locale": "",
      "flag": `${URL}/Flagkit/GA.imageset/GA.png`
    },
    {
      "id": "44",
      "name": "GB",
      "displayText": "United Kingdom (+44)",
      "country": "United Kingdom",
      "locale": "",
      "flag": `${URL}/Flagkit/GB.imageset/GB.png`
    },
    {
      "id": "995",
      "name": "GE",
      "displayText": "Georgia (+995)",
      "country": "Georgia",
      "locale": "",
      "flag": `${URL}/Flagkit/GE.imageset/GE.png`
    },
    {
      "id": "44",
      "name": "GG",
      "displayText": "Guernsey (+44)",
      "country": "Guernsey",
      "locale": "",
      "flag": `${URL}/Flagkit/GG.imageset/GG.png`
    },
    {
      "id": "233",
      "name": "GH",
      "displayText": "Ghana (+233)",
      "country": "Ghana",
      "locale": "",
      "flag": `${URL}/Flagkit/GH.imageset/GH.png`
    },
    {
      "id": "350",
      "name": "GI",
      "displayText": "Gibraltar (+350)",
      "country": "Gibraltar",
      "locale": "",
      "flag": `${URL}/Flagkit/GI.imageset/GI.png`
    },
    {
      "id": "224",
      "name": "GN",
      "displayText": "Guinea (+224)",
      "country": "Guinea",
      "locale": "",
      "flag": `${URL}/Flagkit/GN.imageset/GN.png`
    },
    {
      "id": "590",
      "name": "GP",
      "displayText": "Guadeloupe (+590)",
      "country": "Guadeloupe",
      "locale": "",
      "flag": `${URL}/Flagkit/GP.imageset/GP.png`
    },
    {
      "id": "220",
      "name": "GM",
      "displayText": "Gambia (+220)",
      "country": "Gambia",
      "locale": "",
      "flag": `${URL}/Flagkit/GM.imageset/GM.png`
    },
    {
      "id": "245",
      "name": "GW",
      "displayText": "Guinea-Bissau (+245)",
      "country": "Guinea-Bissau",
      "locale": "",
      "flag": `${URL}/Flagkit/GW.imageset/GW.png`
    },
    {
      "id": "240",
      "name": "GQ",
      "displayText": "Equatorial Guinea (+240)",
      "country": "Equatorial Guinea",
      "locale": "",
      "flag": `${URL}/Flagkit/GQ.imageset/GQ.png`
    },
    {
      "id": "30",
      "name": "GR",
      "displayText": "Greece (+30)",
      "country": "Greece",
      "locale": "",
      "flag": `${URL}/Flagkit/GR.imageset/GR.png`
    },
    {
      "id": "1473",
      "name": "GD",
      "displayText": "Grenada (+1473)",
      "country": "Grenada",
      "locale": "",
      "flag": `${URL}/Flagkit/GD.imageset/GD.png`
    },
    {
      "id": "299",
      "name": "GL",
      "displayText": "Greenland (+299)",
      "country": "Greenland",
      "locale": "",
      "flag": `${URL}/Flagkit/GL.imageset/GL.png`
    },
    {
      "id": "502",
      "name": "GT",
      "displayText": "Guatemala (+502)",
      "country": "Guatemala",
      "locale": "",
      "flag": `${URL}/Flagkit/GT.imageset/GT.png`
    },
    {
      "id": "594",
      "name": "GF",
      "displayText": "French Guiana (+594)",
      "country": "French Guiana",
      "locale": "",
      "flag": `${URL}/Flagkit/GF.imageset/GF.png`
    },
    {
      "id": "1671",
      "name": "GU",
      "displayText": "Guam (+1671)",
      "country": "Guam",
      "locale": "",
      "flag": `${URL}/Flagkit/GU.imageset/GU.png`
    },
    {
      "id": "592",
      "name": "GY",
      "displayText": "Guyana (+592)",
      "country": "Guyana",
      "locale": "",
      "flag": `${URL}/Flagkit/GY.imageset/GY.png`
    },
    {
      "id": "852",
      "name": "HK",
      "displayText": "Hong Kong (+852)",
      "country": "Hong Kong",
      "locale": "",
      "flag": `${URL}/Flagkit/HK.imageset/HK.png`
    },
    {
      "id": "504",
      "name": "HN",
      "displayText": "Honduras (+504)",
      "country": "Honduras",
      "locale": "",
      "flag": `${URL}/Flagkit/HN.imageset/HN.png`
    },
    {
      "id": "385",
      "name": "HR",
      "displayText": "Croatia (+385)",
      "country": "Croatia",
      "locale": "",
      "flag": `${URL}/Flagkit/HR.imageset/HR.png`
    },
    {
      "id": "509",
      "name": "HT",
      "displayText": "Haiti (+509)",
      "country": "Haiti",
      "locale": "",
      "flag": `${URL}/Flagkit/HT.imageset/HT.png`
    },
    {
      "id": "36",
      "name": "HU",
      "displayText": "Hungary (+36)",
      "country": "Hungary",
      "locale": "",
      "flag": `${URL}/Flagkit/HU.imageset/HU.png`
    },
    {
      "id": "62",
      "name": "ID",
      "displayText": "Indonesia (+62)",
      "country": "Indonesia",
      "locale": "",
      "flag": `${URL}/Flagkit/ID.imageset/ID.png`
    },
    {
      "id": "44",
      "name": "IM",
      "displayText": "Isle of Man (+44)",
      "country": "Isle of Man",
      "locale": "",
      "flag": `${URL}/Flagkit/IM.imageset/IM.png`
    },
    {
      "id": "91",
      "name": "IN",
      "displayText": "India (+91)",
      "country": "India",
      "locale": "",
      "flag": `${URL}/Flagkit/IN.imageset/IN.png`
    },
    {
      "id": "246",
      "name": "IO",
      "displayText": "British Indian Ocean Territory (+246)",
      "country": "British Indian Ocean Territory",
      "locale": "",
      "flag": `${URL}/Flagkit/IO.imageset/IO.png`
    },
    {
      "id": "353",
      "name": "IE",
      "displayText": "Ireland (+353)",
      "country": "Ireland",
      "locale": "",
      "flag": `${URL}/Flagkit/IE.imageset/IE.png`
    },
    {
      "id": "98",
      "name": "IR",
      "displayText": "Iran (+98)",
      "country": "Iran",
      "locale": "",
      "flag": `${URL}/Flagkit/IR.imageset/IR.png`
    },
    {
      "id": "964",
      "name": "IQ",
      "displayText": "Iraq (+964)",
      "country": "Iraq",
      "locale": "",
      "flag": `${URL}/Flagkit/IQ.imageset/IQ.png`
    },
    {
      "id": "354",
      "name": "IS",
      "displayText": "Iceland (+354)",
      "country": "Iceland",
      "locale": "",
      "flag": `${URL}/Flagkit/IS.imageset/IS.png`
    },
    {
      "id": "972",
      "name": "IL",
      "displayText": "Israel (+972)",
      "country": "Israel",
      "locale": "",
      "flag": `${URL}/Flagkit/IL.imageset/IL.png`
    },
    {
      "id": "39",
      "name": "IT",
      "displayText": "Italy (+39)",
      "country": "Italy",
      "locale": "",
      "flag": `${URL}/Flagkit/IT.imageset/IT.png`
    },
    {
      "id": "1876",
      "name": "JM",
      "displayText": "Jamaica (+1876)",
      "country": "Jamaica",
      "locale": "",
      "flag": `${URL}/Flagkit/JM.imageset/JM.png`
    },
    {
      "id": "44",
      "name": "JE",
      "displayText": "Jersey (+44)",
      "country": "Jersey",
      "locale": "",
      "flag": `${URL}/Flagkit/JE.imageset/JE.png`
    },
    {
      "id": "962",
      "name": "JO",
      "displayText": "Jordan (+962)",
      "country": "Jordan",
      "locale": "",
      "flag": `${URL}/Flagkit/JO.imageset/JO.png`
    },
    {
      "id": "81",
      "name": "JP",
      "displayText": "Japan (+81)",
      "country": "Japan",
      "locale": "",
      "flag": `${URL}/Flagkit/JP.imageset/JP.png`
    },
    {
      "id": "76",
      "name": "KZ",
      "displayText": "Kazakhstan (+76)",
      "country": "Kazakhstan",
      "locale": "",
      "flag": `${URL}/Flagkit/KZ.imageset/KZ.png`
    },
    {
      "id": "77",
      "name": "KZ",
      "displayText": "Kazakhstan (+77)",
      "country": "Kazakhstan",
      "locale": "",
      "flag": `${URL}/Flagkit/KZ.imageset/KZ.png`
    },
    {
      "id": "254",
      "name": "KE",
      "displayText": "Kenya (+254)",
      "country": "Kenya",
      "locale": "",
      "flag": `${URL}/Flagkit/KE.imageset/KE.png`
    },
    {
      "id": "996",
      "name": "KG",
      "displayText": "Kyrgyzstan (+996)",
      "country": "Kyrgyzstan",
      "locale": "",
      "flag": `${URL}/Flagkit/KG.imageset/KG.png`
    },
    {
      "id": "855",
      "name": "KH",
      "displayText": "Cambodia (+855)",
      "country": "Cambodia",
      "locale": "",
      "flag": `${URL}/Flagkit/KH.imageset/KH.png`
    },
    {
      "id": "686",
      "name": "KI",
      "displayText": "Kiribati (+686)",
      "country": "Kiribati",
      "locale": "",
      "flag": `${URL}/Flagkit/KI.imageset/KI.png`
    },
    {
      "id": "1869",
      "name": "KN",
      "displayText": "Saint Kitts and Nevis (+1869)",
      "country": "Saint Kitts and Nevis",
      "locale": "",
      "flag": `${URL}/Flagkit/KN.imageset/KN.png`
    },
    {
      "id": "82",
      "name": "KR",
      "displayText": "South Korea (+82)",
      "country": "South Korea",
      "locale": "",
      "flag": `${URL}/Flagkit/KR.imageset/KR.png`
    },
    {
      "id": "383",
      "name": "XK",
      "displayText": "Kosovo (+383)",
      "country": "Kosovo",
      "locale": "",
      "flag": `${URL}/Flagkit/XK.imageset/XK.png`
    },
    {
      "id": "965",
      "name": "KW",
      "displayText": "Kuwait (+965)",
      "country": "Kuwait",
      "locale": "",
      "flag": `${URL}/Flagkit/KW.imageset/KW.png`
    },
    {
      "id": "856",
      "name": "LA",
      "displayText": "Laos (+856)",
      "country": "Laos",
      "locale": "",
      "flag": `${URL}/Flagkit/LA.imageset/LA.png`
    },
    {
      "id": "961",
      "name": "LB",
      "displayText": "Lebanon (+961)",
      "country": "Lebanon",
      "locale": "",
      "flag": `${URL}/Flagkit/LB.imageset/LB.png`
    },
    {
      "id": "231",
      "name": "LR",
      "displayText": "Liberia (+231)",
      "country": "Liberia",
      "locale": "",
      "flag": `${URL}/Flagkit/LR.imageset/LR.png`
    },
    {
      "id": "218",
      "name": "LY",
      "displayText": "Libya (+218)",
      "country": "Libya",
      "locale": "",
      "flag": `${URL}/Flagkit/LY.imageset/LY.png`
    },
    {
      "id": "1758",
      "name": "LC",
      "displayText": "Saint Lucia (+1758)",
      "country": "Saint Lucia",
      "locale": "",
      "flag": `${URL}/Flagkit/LC.imageset/LC.png`
    },
    {
      "id": "423",
      "name": "LI",
      "displayText": "Liechtenstein (+423)",
      "country": "Liechtenstein",
      "locale": "",
      "flag": `${URL}/Flagkit/LI.imageset/LI.png`
    },
    {
      "id": "94",
      "name": "LK",
      "displayText": "Sri Lanka (+94)",
      "country": "Sri Lanka",
      "locale": "",
      "flag": `${URL}/Flagkit/LK.imageset/LK.png`
    },
    {
      "id": "266",
      "name": "LS",
      "displayText": "Lesotho (+266)",
      "country": "Lesotho",
      "locale": "",
      "flag": `${URL}/Flagkit/LS.imageset/LS.png`
    },
    {
      "id": "370",
      "name": "LT",
      "displayText": "Lithuania (+370)",
      "country": "Lithuania",
      "locale": "",
      "flag": `${URL}/Flagkit/LT.imageset/LT.png`
    },
    {
      "id": "352",
      "name": "LU",
      "displayText": "Luxembourg (+352)",
      "country": "Luxembourg",
      "locale": "",
      "flag": `${URL}/Flagkit/LU.imageset/LU.png`
    },
    {
      "id": "371",
      "name": "LV",
      "displayText": "Latvia (+371)",
      "country": "Latvia",
      "locale": "",
      "flag": `${URL}/Flagkit/LV.imageset/LV.png`
    },
    {
      "id": "853",
      "name": "MO",
      "displayText": "Macau (+853)",
      "country": "Macau",
      "locale": "",
      "flag": `${URL}/Flagkit/MO.imageset/MO.png`
    },
    {
      "id": "590",
      "name": "MF",
      "displayText": "Saint Martin (+590)",
      "country": "Saint Martin",
      "locale": "",
      "flag": `${URL}/Flagkit/MF.imageset/MF.png`
    },
    {
      "id": "212",
      "name": "MA",
      "displayText": "Morocco (+212)",
      "country": "Morocco",
      "locale": "",
      "flag": `${URL}/Flagkit/MA.imageset/MA.png`
    },
    {
      "id": "377",
      "name": "MC",
      "displayText": "Monaco (+377)",
      "country": "Monaco",
      "locale": "",
      "flag": `${URL}/Flagkit/MC.imageset/MC.png`
    },
    {
      "id": "373",
      "name": "MD",
      "displayText": "Moldova (+373)",
      "country": "Moldova",
      "locale": "",
      "flag": `${URL}/Flagkit/MD.imageset/MD.png`
    },
    {
      "id": "261",
      "name": "MG",
      "displayText": "Madagascar (+261)",
      "country": "Madagascar",
      "locale": "",
      "flag": `${URL}/Flagkit/MG.imageset/MG.png`
    },
    {
      "id": "960",
      "name": "MV",
      "displayText": "Maldives (+960)",
      "country": "Maldives",
      "locale": "",
      "flag": `${URL}/Flagkit/MV.imageset/MV.png`
    },
    {
      "id": "52",
      "name": "MX",
      "displayText": "Mexico (+52)",
      "country": "Mexico",
      "locale": "",
      "flag": `${URL}/Flagkit/MX.imageset/MX.png`
    },
    {
      "id": "692",
      "name": "MH",
      "displayText": "Marshall Islands (+692)",
      "country": "Marshall Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/MH.imageset/MH.png`
    },
    {
      "id": "389",
      "name": "MK",
      "displayText": "Macedonia (+389)",
      "country": "Macedonia",
      "locale": "",
      "flag": `${URL}/Flagkit/MK.imageset/MK.png`
    },
    {
      "id": "223",
      "name": "ML",
      "displayText": "Mali (+223)",
      "country": "Mali",
      "locale": "",
      "flag": `${URL}/Flagkit/ML.imageset/ML.png`
    },
    {
      "id": "356",
      "name": "MT",
      "displayText": "Malta (+356)",
      "country": "Malta",
      "locale": "",
      "flag": `${URL}/Flagkit/MT.imageset/MT.png`
    },
    {
      "id": "95",
      "name": "MM",
      "displayText": "Myanmar (+95)",
      "country": "Myanmar",
      "locale": "",
      "flag": `${URL}/Flagkit/MM.imageset/MM.png`
    },
    {
      "id": "382",
      "name": "ME",
      "displayText": "Montenegro (+382)",
      "country": "Montenegro",
      "locale": "",
      "flag": `${URL}/Flagkit/ME.imageset/ME.png`
    },
    {
      "id": "976",
      "name": "MN",
      "displayText": "Mongolia (+976)",
      "country": "Mongolia",
      "locale": "",
      "flag": `${URL}/Flagkit/MN.imageset/MN.png`
    },
    {
      "id": "1670",
      "name": "MP",
      "displayText": "Northern Mariana Islands (+1670)",
      "country": "Northern Mariana Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/MP.imageset/MP.png`
    },
    {
      "id": "258",
      "name": "MZ",
      "displayText": "Mozambique (+258)",
      "country": "Mozambique",
      "locale": "",
      "flag": `${URL}/Flagkit/MZ.imageset/MZ.png`
    },
    {
      "id": "222",
      "name": "MR",
      "displayText": "Mauritania (+222)",
      "country": "Mauritania",
      "locale": "",
      "flag": `${URL}/Flagkit/MR.imageset/MR.png`
    },
    {
      "id": "1664",
      "name": "MS",
      "displayText": "Montserrat (+1664)",
      "country": "Montserrat",
      "locale": "",
      "flag": `${URL}/Flagkit/MS.imageset/MS.png`
    },
    {
      "id": "596",
      "name": "MQ",
      "displayText": "Martinique (+596)",
      "country": "Martinique",
      "locale": "",
      "flag": `${URL}/Flagkit/MQ.imageset/MQ.png`
    },
    {
      "id": "230",
      "name": "MU",
      "displayText": "Mauritius (+230)",
      "country": "Mauritius",
      "locale": "",
      "flag": `${URL}/Flagkit/MU.imageset/MU.png`
    },
    {
      "id": "265",
      "name": "MW",
      "displayText": "Malawi (+265)",
      "country": "Malawi",
      "locale": "",
      "flag": `${URL}/Flagkit/MW.imageset/MW.png`
    },
    {
      "id": "60",
      "name": "MY",
      "displayText": "Malaysia (+60)",
      "country": "Malaysia",
      "locale": "",
      "flag": `${URL}/Flagkit/MY.imageset/MY.png`
    },
    {
      "id": "262",
      "name": "YT",
      "displayText": "Mayotte (+262)",
      "country": "Mayotte",
      "locale": "",
      "flag": `${URL}/Flagkit/YT.imageset/YT.png`
    },
    {
      "id": "264",
      "name": "NA",
      "displayText": "Namibia (+264)",
      "country": "Namibia",
      "locale": "",
      "flag": `${URL}/Flagkit/NA.imageset/NA.png`
    },
    {
      "id": "687",
      "name": "NC",
      "displayText": "New Caledonia (+687)",
      "country": "New Caledonia",
      "locale": "",
      "flag": `${URL}/Flagkit/NC.imageset/NC.png`
    },
    {
      "id": "227",
      "name": "NE",
      "displayText": "Niger (+227)",
      "country": "Niger",
      "locale": "",
      "flag": `${URL}/Flagkit/NE.imageset/NE.png`
    },
    {
      "id": "672",
      "name": "NF",
      "displayText": "Norfolk Island (+672)",
      "country": "Norfolk Island",
      "locale": "",
      "flag": `${URL}/Flagkit/NF.imageset/NF.png`
    },
    {
      "id": "234",
      "name": "NG",
      "displayText": "Nigeria (+234)",
      "country": "Nigeria",
      "locale": "",
      "flag": `${URL}/Flagkit/NG.imageset/NG.png`
    },
    {
      "id": "505",
      "name": "NI",
      "displayText": "Nicaragua (+505)",
      "country": "Nicaragua",
      "locale": "",
      "flag": `${URL}/Flagkit/NI.imageset/NI.png`
    },
    {
      "id": "683",
      "name": "NU",
      "displayText": "Niue (+683)",
      "country": "Niue",
      "locale": "",
      "flag": `${URL}/Flagkit/NU.imageset/NU.png`
    },
    {
      "id": "31",
      "name": "NL",
      "displayText": "Netherlands (+31)",
      "country": "Netherlands",
      "locale": "",
      "flag": `${URL}/Flagkit/NL.imageset/NL.png`
    },
    {
      "id": "47",
      "name": "NO",
      "displayText": "Norway (+47)",
      "country": "Norway",
      "locale": "",
      "flag": `${URL}/Flagkit/NO.imageset/NO.png`
    },
    {
      "id": "977",
      "name": "NP",
      "displayText": "Nepal (+977)",
      "country": "Nepal",
      "locale": "",
      "flag": `${URL}/Flagkit/NP.imageset/NP.png`
    },
    {
      "id": "674",
      "name": "NR",
      "displayText": "Nauru (+674)",
      "country": "Nauru",
      "locale": "",
      "flag": `${URL}/Flagkit/NR.imageset/NR.png`
    },
    {
      "id": "64",
      "name": "NZ",
      "displayText": "New Zealand (+64)",
      "country": "New Zealand",
      "locale": "",
      "flag": `${URL}/Flagkit/NZ.imageset/NZ.png`
    },
    {
      "id": "968",
      "name": "OM",
      "displayText": "Oman (+968)",
      "country": "Oman",
      "locale": "",
      "flag": `${URL}/Flagkit/OM.imageset/OM.png`
    },
    {
      "id": "92",
      "name": "PK",
      "displayText": "Pakistan (+92)",
      "country": "Pakistan",
      "locale": "",
      "flag": `${URL}/Flagkit/PK.imageset/PK.png`
    },
    {
      "id": "507",
      "name": "PA",
      "displayText": "Panama (+507)",
      "country": "Panama",
      "locale": "",
      "flag": `${URL}/Flagkit/PA.imageset/PA.png`
    },
    {
      "id": "64",
      "name": "PN",
      "displayText": "Pitcairn Islands (+64)",
      "country": "Pitcairn Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/PN.imageset/PN.png`
    },
    {
      "id": "51",
      "name": "PE",
      "displayText": "Peru (+51)",
      "country": "Peru",
      "locale": "",
      "flag": `${URL}/Flagkit/PE.imageset/PE.png`
    },
    {
      "id": "63",
      "name": "PH",
      "displayText": "Philippines (+63)",
      "country": "Philippines",
      "locale": "",
      "flag": `${URL}/Flagkit/PH.imageset/PH.png`
    },
    {
      "id": "680",
      "name": "PW",
      "displayText": "Palau (+680)",
      "country": "Palau",
      "locale": "",
      "flag": `${URL}/Flagkit/PW.imageset/PW.png`
    },
    {
      "id": "675",
      "name": "PG",
      "displayText": "Papua New Guinea (+675)",
      "country": "Papua New Guinea",
      "locale": "",
      "flag": `${URL}/Flagkit/PG.imageset/PG.png`
    },
    {
      "id": "48",
      "name": "PL",
      "displayText": "Poland (+48)",
      "country": "Poland",
      "locale": "",
      "flag": `${URL}/Flagkit/PL.imageset/PL.png`
    },
    {
      "id": "1",
      "name": "PR",
      "displayText": "Puerto Rico (+1)",
      "country": "Puerto Rico",
      "locale": "",
      "flag": `${URL}/Flagkit/PR.imageset/PR.png`
    },
    {
      "id": "1939",
      "name": "PR",
      "displayText": "Puerto Rico (+1939)",
      "country": "Puerto Rico",
      "locale": "",
      "flag": `${URL}/Flagkit/PR.imageset/PR.png`
    },
    {
      "id": "850",
      "name": "KP",
      "displayText": "North Korea (+850)",
      "country": "North Korea",
      "locale": "",
      "flag": `${URL}/Flagkit/KP.imageset/KP.png`
    },
    {
      "id": "351",
      "name": "PT",
      "displayText": "Portugal (+351)",
      "country": "Portugal",
      "locale": "",
      "flag": `${URL}/Flagkit/PT.imageset/PT.png`
    },
    {
      "id": "595",
      "name": "PY",
      "displayText": "Paraguay (+595)",
      "country": "Paraguay",
      "locale": "",
      "flag": `${URL}/Flagkit/PY.imageset/PY.png`
    },
    {
      "id": "970",
      "name": "PS",
      "displayText": "Palestine (+970)",
      "country": "Palestine",
      "locale": "",
      "flag": `${URL}/Flagkit/PS.imageset/PS.png`
    },
    {
      "id": "689",
      "name": "PF",
      "displayText": "French Polynesia (+689)",
      "country": "French Polynesia",
      "locale": "",
      "flag": `${URL}/Flagkit/PF.imageset/PF.png`
    },
    {
      "id": "974",
      "name": "QA",
      "displayText": "Qatar (+974)",
      "country": "Qatar",
      "locale": "",
      "flag": `${URL}/Flagkit/QA.imageset/QA.png`
    },
    {
      "id": "262",
      "name": "RE",
      "displayText": "RÃ©union (+262)",
      "country": "RÃ©union",
      "locale": "",
      "flag": `${URL}/Flagkit/RE.imageset/RE.png`
    },
    {
      "id": "40",
      "name": "RO",
      "displayText": "Romania (+40)",
      "country": "Romania",
      "locale": "",
      "flag": `${URL}/Flagkit/RO.imageset/RO.png`
    },
    {
      "id": "7",
      "name": "RU",
      "displayText": "Russia (+7)",
      "country": "Russia",
      "locale": "",
      "flag": `${URL}/Flagkit/RU.imageset/RU.png`
    },
    {
      "id": "250",
      "name": "RW",
      "displayText": "Rwanda (+250)",
      "country": "Rwanda",
      "locale": "",
      "flag": `${URL}/Flagkit/RW.imageset/RW.png`
    },
    {
      "id": "966",
      "name": "SA",
      "displayText": "Saudi Arabia (+966)",
      "country": "Saudi Arabia",
      "locale": "",
      "flag": `${URL}/Flagkit/SA.imageset/SA.png`
    },
    {
      "id": "249",
      "name": "SD",
      "displayText": "Sudan (+249)",
      "country": "Sudan",
      "locale": "",
      "flag": `${URL}/Flagkit/SD.imageset/SD.png`
    },
    {
      "id": "221",
      "name": "SN",
      "displayText": "Senegal (+221)",
      "country": "Senegal",
      "locale": "",
      "flag": `${URL}/Flagkit/SN.imageset/SN.png`
    },
    {
      "id": "65",
      "name": "SG",
      "displayText": "Singapore (+65)",
      "country": "Singapore",
      "locale": "",
      "flag": `${URL}/Flagkit/SG.imageset/SG.png`
    },
    {
      "id": "500",
      "name": "GS",
      "displayText": "South Georgia (+500)",
      "country": "South Georgia",
      "locale": "",
      "flag": `${URL}/Flagkit/GS.imageset/GS.png`
    },
    {
      "id": "4779",
      "name": "SJ",
      "displayText": "Svalbard and Jan Mayen (+4779)",
      "country": "Svalbard and Jan Mayen",
      "locale": "",
      "flag": `${URL}/Flagkit/SJ.imageset/SJ.png`
    },
    {
      "id": "677",
      "name": "SB",
      "displayText": "Solomon Islands (+677)",
      "country": "Solomon Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/SB.imageset/SB.png`
    },
    {
      "id": "232",
      "name": "SL",
      "displayText": "Sierra Leone (+232)",
      "country": "Sierra Leone",
      "locale": "",
      "flag": `${URL}/Flagkit/SL.imageset/SL.png`
    },
    {
      "id": "503",
      "name": "SV",
      "displayText": "El Salvador (+503)",
      "country": "El Salvador",
      "locale": "",
      "flag": `${URL}/Flagkit/SV.imageset/SV.png`
    },
    {
      "id": "378",
      "name": "SM",
      "displayText": "San Marino (+378)",
      "country": "San Marino",
      "locale": "",
      "flag": `${URL}/Flagkit/SM.imageset/SM.png`
    },
    {
      "id": "252",
      "name": "SO",
      "displayText": "Somalia (+252)",
      "country": "Somalia",
      "locale": "",
      "flag": `${URL}/Flagkit/SO.imageset/SO.png`
    },
    {
      "id": "508",
      "name": "PM",
      "displayText": "Saint Pierre and Miquelon (+508)",
      "country": "Saint Pierre and Miquelon",
      "locale": "",
      "flag": `${URL}/Flagkit/PM.imageset/PM.png`
    },
    {
      "id": "381",
      "name": "RS",
      "displayText": "Serbia (+381)",
      "country": "Serbia",
      "locale": "",
      "flag": `${URL}/Flagkit/RS.imageset/RS.png`
    },
    {
      "id": "211",
      "name": "SS",
      "displayText": "South Sudan (+211)",
      "country": "South Sudan",
      "locale": "",
      "flag": `${URL}/Flagkit/SS.imageset/SS.png`
    },
    {
      "id": "239",
      "name": "ST",
      "displayText": "SÃ£o TomÃ© and PrÃ­ncipe (+239)",
      "country": "SÃ£o TomÃ© and PrÃ­ncipe",
      "locale": "",
      "flag": `${URL}/Flagkit/ST.imageset/ST.png`
    },
    {
      "id": "597",
      "name": "SR",
      "displayText": "Suriname (+597)",
      "country": "Suriname",
      "locale": "",
      "flag": `${URL}/Flagkit/SR.imageset/SR.png`
    },
    {
      "id": "421",
      "name": "SK",
      "displayText": "Slovakia (+421)",
      "country": "Slovakia",
      "locale": "",
      "flag": `${URL}/Flagkit/SK.imageset/SK.png`
    },
    {
      "id": "386",
      "name": "SI",
      "displayText": "Slovenia (+386)",
      "country": "Slovenia",
      "locale": "",
      "flag": `${URL}/Flagkit/SI.imageset/SI.png`
    },
    {
      "id": "46",
      "name": "SE",
      "displayText": "Sweden (+46)",
      "country": "Sweden",
      "locale": "",
      "flag": `${URL}/Flagkit/SE.imageset/SE.png`
    },
    {
      "id": "268",
      "name": "SZ",
      "displayText": "Swaziland (+268)",
      "country": "Swaziland",
      "locale": "",
      "flag": `${URL}/Flagkit/SZ.imageset/SZ.png`
    },
    {
      "id": "1721",
      "name": "SX",
      "displayText": "Sint Maarten (+1721)",
      "country": "Sint Maarten",
      "locale": "",
      "flag": `${URL}/Flagkit/SX.imageset/SX.png`
    },
    {
      "id": "248",
      "name": "SC",
      "displayText": "Seychelles (+248)",
      "country": "Seychelles",
      "locale": "",
      "flag": `${URL}/Flagkit/SC.imageset/SC.png`
    },
    {
      "id": "963",
      "name": "SY",
      "displayText": "Syria (+963)",
      "country": "Syria",
      "locale": "",
      "flag": `${URL}/Flagkit/SY.imageset/SY.png`
    },
    {
      "id": "1649",
      "name": "TC",
      "displayText": "Turks and Caicos Islands (+1649)",
      "country": "Turks and Caicos Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/TC.imageset/TC.png`
    },
    {
      "id": "235",
      "name": "TD",
      "displayText": "Chad (+235)",
      "country": "Chad",
      "locale": "",
      "flag": `${URL}/Flagkit/TD.imageset/TD.png`
    },
    {
      "id": "228",
      "name": "TG",
      "displayText": "Togo (+228)",
      "country": "Togo",
      "locale": "",
      "flag": `${URL}/Flagkit/TG.imageset/TG.png`
    },
    {
      "id": "66",
      "name": "TH",
      "displayText": "Thailand (+66)",
      "country": "Thailand",
      "locale": "",
      "flag": `${URL}/Flagkit/TH.imageset/TH.png`
    },
    {
      "id": "992",
      "name": "TJ",
      "displayText": "Tajikistan (+992)",
      "country": "Tajikistan",
      "locale": "",
      "flag": `${URL}/Flagkit/TJ.imageset/TJ.png`
    },
    {
      "id": "690",
      "name": "TK",
      "displayText": "Tokelau (+690)",
      "country": "Tokelau",
      "locale": "",
      "flag": `${URL}/Flagkit/TK.imageset/TK.png`
    },
    {
      "id": "993",
      "name": "TM",
      "displayText": "Turkmenistan (+993)",
      "country": "Turkmenistan",
      "locale": "",
      "flag": `${URL}/Flagkit/TM.imageset/TM.png`
    },
    {
      "id": "670",
      "name": "TL",
      "displayText": "Timor-Leste (+670)",
      "country": "Timor-Leste",
      "locale": "",
      "flag": `${URL}/Flagkit/TL.imageset/TL.png`
    },
    {
      "id": "676",
      "name": "TO",
      "displayText": "Tonga (+676)",
      "country": "Tonga",
      "locale": "",
      "flag": `${URL}/Flagkit/TO.imageset/TO.png`
    },
    {
      "id": "1",
      "name": "TT",
      "displayText": "Trinidad and Tobago (+1)",
      "country": "Trinidad and Tobago",
      "locale": "",
      "flag": `${URL}/Flagkit/TT.imageset/TT.png`
    },
    {
      "id": "216",
      "name": "TN",
      "displayText": "Tunisia (+216)",
      "country": "Tunisia",
      "locale": "",
      "flag": `${URL}/Flagkit/TN.imageset/TN.png`
    },
    {
      "id": "90",
      "name": "TR",
      "displayText": "Turkey (+90)",
      "country": "Turkey",
      "locale": "",
      "flag": `${URL}/Flagkit/TR.imageset/TR.png`
    },
    {
      "id": "688",
      "name": "TV",
      "displayText": "Tuvalu (+688)",
      "country": "Tuvalu",
      "locale": "",
      "flag": `${URL}/Flagkit/TV.imageset/TV.png`
    },
    {
      "id": "886",
      "name": "TW",
      "displayText": "Taiwan (+886)",
      "country": "Taiwan",
      "locale": "",
      "flag": `${URL}/Flagkit/TW.imageset/TW.png`
    },
    {
      "id": "255",
      "name": "TZ",
      "displayText": "Tanzania (+255)",
      "country": "Tanzania",
      "locale": "",
      "flag": `${URL}/Flagkit/TZ.imageset/TZ.png`
    },
    {
      "id": "256",
      "name": "UG",
      "displayText": "Uganda (+256)",
      "country": "Uganda",
      "locale": "",
      "flag": `${URL}/Flagkit/UG.imageset/UG.png`
    },
    {
      "id": "380",
      "name": "UA",
      "displayText": "Ukraine (+380)",
      "country": "Ukraine",
      "locale": "",
      "flag": `${URL}/Flagkit/UA.imageset/UA.png`
    },
    {
      "id": "598",
      "name": "UY",
      "displayText": "Uruguay (+598)",
      "country": "Uruguay",
      "locale": "",
      "flag": `${URL}/Flagkit/UY.imageset/UY.png`
    },
    {
      "id": "998",
      "name": "UZ",
      "displayText": "Uzbekistan (+998)",
      "country": "Uzbekistan",
      "locale": "",
      "flag": `${URL}/Flagkit/UZ.imageset/UZ.png`
    },
    {
      "id": "3906698",
      "name": "VA",
      "displayText": "Vatican City (+3906698)",
      "country": "Vatican City",
      "locale": "",
      "flag": `${URL}/Flagkit/VA.imageset/VA.png`
    },
    {
      "id": "379",
      "name": "VA",
      "displayText": "Vatican City (+379)",
      "country": "Vatican City",
      "locale": "",
      "flag": `${URL}/Flagkit/VA.imageset/VA.png`
    },
    {
      "id": "1784",
      "name": "VC",
      "displayText": "Saint Vincent and the Grenadines (+1784)",
      "country": "Saint Vincent and the Grenadines",
      "locale": "",
      "flag": `${URL}/Flagkit/VC.imageset/VC.png`
    },
    {
      "id": "58",
      "name": "VE",
      "displayText": "Venezuela (+58)",
      "country": "Venezuela",
      "locale": "",
      "flag": `${URL}/Flagkit/VE.imageset/VE.png`
    },
    {
      "id": "1284",
      "name": "VG",
      "displayText": "British Virgin Islands (+1284)",
      "country": "British Virgin Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/VG.imageset/VG.png`
    },
    {
      "id": "1340",
      "name": "VI",
      "displayText": "United States Virgin Islands (+1340)",
      "country": "United States Virgin Islands",
      "locale": "",
      "flag": `${URL}/Flagkit/VI.imageset/VI.png`
    },
    {
      "id": "84",
      "name": "VN",
      "displayText": "Vietnam (+84)",
      "country": "Vietnam",
      "locale": "",
      "flag": `${URL}/Flagkit/VN.imageset/VN.png`
    },
    {
      "id": "678",
      "name": "VU",
      "displayText": "Vanuatu (+678)",
      "country": "Vanuatu",
      "locale": "",
      "flag": `${URL}/Flagkit/VU.imageset/VU.png`
    },
    {
      "id": "681",
      "name": "WF",
      "displayText": "Wallis and Futuna (+681)",
      "country": "Wallis and Futuna",
      "locale": "",
      "flag": `${URL}/Flagkit/WF.imageset/WF.png`
    },
    {
      "id": "685",
      "name": "WS",
      "displayText": "Samoa (+685)",
      "country": "Samoa",
      "locale": "",
      "flag": `${URL}/Flagkit/WS.imageset/WS.png`
    },
    {
      "id": "967",
      "name": "YE",
      "displayText": "Yemen (+967)",
      "country": "Yemen",
      "locale": "",
      "flag": `${URL}/Flagkit/YE.imageset/YE.png`
    },
    {
      "id": "27",
      "name": "ZA",
      "displayText": "South Africa (+27)",
      "country": "South Africa",
      "locale": "",
      "flag": `${URL}/Flagkit/ZA.imageset/ZA.png`
    },
    {
      "id": "260",
      "name": "ZM",
      "displayText": "Zambia (+260)",
      "country": "Zambia",
      "locale": "",
      "flag": `${URL}/Flagkit/ZM.imageset/ZM.png`
    },
    {
      "id": "263",
      "name": "ZW",
      "displayText": "Zimbabwe (+263)",
      "country": "Zimbabwe",
      "locale": "",
      "flag": `${URL}/Flagkit/ZW.imageset/ZW.png`
    }
  ]
};

export const carMakeList = [
  { value: "Acura", label: "Acura", id: 10, isModal: true, scale: 0.5, height: 30 },
  { value: "Alfa Romeo", label: "Alfa Romeo", id: 35, isModal: true, scale: 0.5 },
  { value: "Aston Martin", label: "Aston Martin", id: 21, isModal: true, scale: 0.5 },
  { value: "Audi", label: "Audi", id: 3, isModal: true, scale: 0.5 },
  { value: "BMW", label: "BMW", id: 2, isModal: true, scale: 0.5, height: 30 },
  { value: "Bentley", label: "Bentley", id: 19, isModal: true, scale: 0.5 },
  { value: "Buick", label: "Buick", id: 36, isModal: true, scale: 0.5 },
  { value: "Cadillac", label: "Cadillac", id: 6, isModal: true, scale: 0.5, height: 30 },
  { value: "Chevrolet", label: "Chevrolet", id: 26, isModal: true, scale: 0.5 },
  { value: "Chrysler", label: "Chrysler", id: 16, isModal: true, scale: 1 },
  { value: "Corvette", label: "Corvette", id: 49, isModal: true, scale: 0.5 },
  { value: "Dodge", label: "Dodge", id: 39, isModal: true, scale: 0.5, height: 36 },
  { value: "Fiat", label: "Fiat", id: 48, isModal: true, scale: 0.5 },
  { value: "Ferrari", label: "Ferrari", id: 20, isModal: true, scale: 0.5 },
  { value: "Ford", label: "Ford", id: 11, isModal: true, scale: 0.5, height: 30 },
  { value: "GMC", label: "GMC", id: 24, isModal: true, scale: 0.5, height: 30 },
  { value: "Genesis", label: "Genesis", id: 28, isModal: true, scale: 0.5 },
  { value: "Honda", label: "Honda", id: 27, isModal: true, scale: 0.5, height: 50 },
  { value: "Hummer", label: "Hummer", id: 34, isModal: true, scale: 0.5 },
  { value: "Hyundai", label: "Hyundai", id: 30, isModal: true, scale: 0.5, height: 35 },
  { value: "Ineos", label: "Ineos", id: 52, isModal: true, scale: 0.5 },
  { value: "Infiniti", label: "Infiniti", id: 29, isModal: true, scale: 0.5 },
  { value: "Jaguar", label: "Jaguar", id: 8, isModal: true, scale: 0.5 },
  { value: "Jeep", label: "Jeep", id: 15, isModal: true, scale: 0.5 },
  { value: "Kia", label: "Kia", id: 25, isModal: true, scale: 0.5, height: 30 },
  { value: "Lamborghini", label: "Lamborghini", id: 13, isModal: true, scale: 0.5 },
  { value: "Land Rover", label: "Land Rover", id: 45, isModal: true, scale: 0.5 },
  { value: "Lexus", label: "Lexus", id: 4, isModal: true, scale: 0.5 },
  { value: "Lincoln", label: "Lincoln", id: 17, isModal: true, scale: 0.5 },
  { value: "Lotus", label: "Lotus", id: 32, isModal: true, scale: 0.5 },
  { value: "Lucid", label: "Lucid", id: 51, isModal: true, scale: 0.5 },
  { value: "Maserati", label: "Maserati", id: 9, isModal: true, scale: 0.5 },
  { value: "Mazda", label: "Mazda", id: 38, isModal: true, scale: 0.5, height: 30 },
  { value: "McLaren", label: "McLaren", id: 12, isModal: true, scale: 0.5 },
  { value: "Mercedes", label: "Mercedes", id: 1, isModal: true, scale: 0.5, height: 30 },
  { value: "Mini", label: "Mini", id: 33, isModal: true, scale: 0.5 },
  { value: "Mitsubishi", label: "Mitsubishi", id: 44, isModal: true, scale: 0.5 },
  { value: "Nissan", label: "Nissan", id: 37, isModal: true, scale: 0.5 },
  { value: "Oldsmobile", label: "Oldsmobile", id: 46, isModal: true, scale: 0.45 },
  { value: "Polestar", label: "Polestar", id: 42, isModal: true, scale: 0.5 },
  { value: "Pontiac", label: "Pontiac", id: 47, isModal: true, scale: 0.5 },
  { value: "Porsche", label: "Porsche", id: 5, isModal: true, scale: 0.5 },
  { value: "Ram", label: "Ram", id: 23, isModal: true, scale: 0.5 },
  { value: "Rivian", label: "Rivian", id: 53, isModal: true, scale: 0.5 },
  { value: "Rolls-Royce", label: "Rolls-Royce", id: 14, isModal: true, scale: 0.5 },
  { value: "Saturn", label: "Saturn", id: 50, isModal: true, scale: 0.5 },
  { value: "Scion", label: "Scion", id: 40, isModal: true, scale: 0.5 },
  { value: "Subaru", label: "Subaru", id: 41, isModal: true, scale: 0.5, height: 30 },
  { value: "Suzuki", label: "Suzuki", id: 43, isModal: true, scale: 0.5 },
  { value: "Tesla", label: "Tesla", id: 7, isModal: true, scale: 0.5, height: 50 },
  { value: "Toyota", label: "Toyota", id: 31, isModal: true, scale: 0.5, height: 50 },
  { value: "Volkswagen", label: "Volkswagen", id: 18, isModal: true, scale: 0.5, height: 30 },
  { value: "Volvo", label: "Volvo", id: 22, isModal: true, scale: 0.5, height: 30 },
  { value: "Others", label: "Others", id: 99, isModal: true }
];

export const carColorList = [
  { value: "beige", label: "Beige" },
  { value: "black", label: "Black" },
  { value: "blue", label: "Blue" },
  { value: "brown", label: "Brown" },
  { value: "gold", label: "Gold" },
  { value: "gray", label: "Grey" },
  { value: "green", label: "Green" },
  { value: "maroon", label: "Maroon" },
  { value: "orange", label: "Orange" },
  { value: "pink", label: "Pink" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "silver", label: "Silver" },
  { value: "white", label: "White" },
  { value: "yellow", label: "Yellow" },
  { value: "others", label: "Others" }
];


export { data as default };
